import { timezones } from '@/constants/localizer';

export default {
  user: store => store.user,
  authenticated: store => !!store.token,
  token: store => store.token,
  isSuperAdmin: store => !!(store.user && store.user.superAdmin),
  isAdmin: store => !!(store.user && store.user.isAdmin),
  temporaryAccessData: store => store.temporaryAccessData,
  recoverData: store => store.recoverData,
  hasAnyAccessPending: store => store.accessPending.length > 0,
  accessPending: store => [...store.accessPending],
  ianaZone: store => store.user?.timezoneId || timezones.DEFAULT,
  isRefreshTokenExpired: store => store.isRefreshTokenExpired,
  refreshTokenExpiration: store => store.refreshTokenExpiration,
};
